// ============================================
// Utils - Date/Time Formatting (ES6)
// 날짜/시간 포맷팅 기능
// ============================================

// 상대 시간 포맷 (채팅/세션 목록용)
export function formatChatDate(date) {
  if (!date) return '';

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  // 1분 이내
  if (diffMinutes < 1) return '방금';

  // 1시간 이내
  if (diffMinutes < 60) return `${diffMinutes}분전`;

  // 24시간 이내
  if (diffHours < 24) return `${diffHours}시간전`;

  // 어제
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today.getTime() - 86400000);
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  if (dateOnly.getTime() === yesterday.getTime()) return '어제';

  // 7일 이내
  if (diffDays < 7) return `${diffDays}일전`;

  // 올해
  if (date.getFullYear() === now.getFullYear()) {
    return `${date.getMonth() + 1}월 ${date.getDate()}일`;
  }

  // 작년 이전
  return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`;
}

// 시간 포맷 (PM 02:30)
export function formatTime(date) {
  if (!date) return '';
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHours = (hours % 12 || 12).toString().padStart(2, '0');
  return `${period} ${displayHours}:${minutes}`;
}

// window 노출 제거됨 (2026-01-06) - import로 사용
